<template>
  <div class="input-insert-button">
    <a class="cursor-pointer" @click="showDialog = true">
      <v-icon start size="14" color="accent">md:add</v-icon>
      <span>Insert link</span>
    </a>
    <v-dialog v-model="showDialog" width="550" maxWidth="550">
      <v-card>
        <v-card-title class="headline">Insert link into {{ title }}</v-card-title>
        <v-card-text>
          <v-text-field
            v-model.trim="linkText"
            variant="outlined"
            persistentPlaceholder
            density="compact"
            label="Link text to display"
            :placeholder="`e.g.: ${textPlaceholder}`"
            hideDetails
          ></v-text-field>
        </v-card-text>
        <v-card-text>
          <v-text-field
            v-model.trim="linkURL"
            variant="outlined"
            persistentPlaceholder
            density="compact"
            label="Link URL"
            :placeholder="`e.g.: ${urlPlaceholder}`"
            hideDetails
          ></v-text-field>
        </v-card-text>
        <v-card-actions class="modal-card-actions-div">
          <RfButton
            buttonText="Cancel"
            class="cancel-btn px-5!"
            variant="outlined"
            @click="closeInsertModal"
          />
          <RfButton color="primary" buttonText="Insert link" class="px-7!" @click="insertLink" />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup>
import { ref } from "vue";
import RfButton from "@/components/buttons/RfButton.vue";

const props = defineProps([
  "title",
  "textPlaceholder",
  "urlPlaceholder",
  "deviceType",
  "insertColor",
  "modelValue",
]);
const emit = defineEmits("update:modelValue");

const showDialog = ref(false);
const linkText = ref("");
const linkURL = ref("");

const insertLink = () => {
  let innerHtml = props.modelValue?.length ? `${props.modelValue} ` : "";
  innerHtml +=
    props.deviceType === "web"
      ? `<a href="${linkURL.value}"` +
        ` style="color:${props.insertColor};text-decoration:underline"` +
        ` target="_blank">${linkText.value}</a>`
      : `[[${linkText.value}|${linkURL.value}]]`;

  emit("update:modelValue", innerHtml);

  closeInsertModal();
};

const closeInsertModal = () => {
  showDialog.value = false;
  linkURL.value = "";
  linkText.value = "";
};
</script>
